"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Session = exports.SessionPaymentStatus = exports.SessionState = exports.SessionType = void 0;
const base_model_1 = __importDefault(require("./base-model"));
const defaults_1 = require("./defaults");
var SessionType;
(function (SessionType) {
    SessionType["CASE_MANAGEMENT"] = "CASE_MANAGEMENT";
    SessionType["THERAPY"] = "THERAPY";
})(SessionType = exports.SessionType || (exports.SessionType = {}));
var SessionState;
(function (SessionState) {
    SessionState["INCOMPLETE"] = "INCOMPLETE";
    SessionState["COMPLETE"] = "COMPLETE";
})(SessionState = exports.SessionState || (exports.SessionState = {}));
var SessionPaymentStatus;
(function (SessionPaymentStatus) {
    SessionPaymentStatus["PAID"] = "PAID";
    SessionPaymentStatus["PENDING"] = "PENDING";
    SessionPaymentStatus["UNSET"] = "UNSET";
})(SessionPaymentStatus = exports.SessionPaymentStatus || (exports.SessionPaymentStatus = {}));
class Session extends base_model_1.default {
    constructor(data = {
        id: null,
        session_type: null,
        state: SessionState.INCOMPLETE,
    }) {
        var _a;
        super(data);
        this.id = defaults_1.defaultString(data.id);
        this.session_type = defaults_1.defaultEnum((_a = data.session_type) === null || _a === void 0 ? void 0 : _a.toUpperCase(), SessionType);
        this.state = data.state;
        // This is the only entity so it will next have a previous or next entity
        this.next = null;
        this.previous = null;
    }
    get sessionType() {
        return this.session_type;
    }
    get completed() {
        return this.state === SessionState.COMPLETE;
    }
}
exports.Session = Session;
class SessionSection extends base_model_1.default {
    constructor(data = {
        id: null,
        name: null,
        order: null,
        session_type: null,
        payment_status: null,
        state: null,
        next: null,
        previous: null,
    }) {
        super(data);
        this.name = defaults_1.defaultString(data.name);
        this.order = defaults_1.defaultNumber(data.order);
        this.session_type = defaults_1.defaultEnum(data.session_type, SessionType);
        this.payment_status = defaults_1.defaultEnum(data.payment_status, SessionPaymentStatus);
        this.state = defaults_1.defaultEnum(data.state, SessionState);
        this.next = defaults_1.defaultString(data.next);
        this.previous = defaults_1.defaultString(data.previous);
    }
    get data() {
        // This section only can have one element
        return [this.entities.sessionsection[this.id]];
    }
    get contents() {
        // Setup to mirror normalization on ContentSections
        return [{ id: this.id, schema: "sessionsection" }];
    }
    get entities() {
        // Setup to mirror normalization on ContentSections
        return { "sessionsection": { [this.id]: new Session({ session_type: this.sessionType, id: this.id, state: this.state }) } };
    }
    get sessionType() {
        return this.session_type;
    }
    get completed() {
        return this.state === SessionState.COMPLETE;
    }
}
exports.default = SessionSection;
